import { render, staticRenderFns } from "./BannerListCreate.vue?vue&type=template&id=f27ceedc&scoped=true"
import script from "./BannerListCreate.vue?vue&type=script&lang=js"
export * from "./BannerListCreate.vue?vue&type=script&lang=js"
import style0 from "./BannerListCreate.vue?vue&type=style&index=0&id=f27ceedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27ceedc",
  null
  
)

export default component.exports